module.exports = __webpack_public_path__ + "img/Chevron-Down_24px_2_Icon_white.9f7bdd1c.svg";